import React from "react";
import Input from "../../../components/ui/Input";
import Icon from "../../../components/AppIcon";
import Select from "../../../components/ui/Select";

const RoofEngineeringForm = ({ surveyData, errors, onChange }) => {
  const handleChange = (field, value) => {
    onChange(field, value);
  };

  const roofTypeOptions = [
    { value: "RCC Flat", label: "RCC Flat" },
    { value: "Tiled", label: "Tiled" },
    { value: "Sheet", label: "Sheet" },
    { value: "Asbestos", label: "Asbestos" },
    { value: "Thatched", label: "Thatched" },
  ];

  const roofConditionOptions = [
    { value: "New", label: "New" },
    { value: "Good", label: "Good" },
    { value: "Cracks", label: "Cracks" },
    { value: "Leaking", label: "Leaking" },
    { value: "Weak", label: "Weak" },
  ];

  const roofOrientationOptions = [
    { value: "North", label: "North" },
    { value: "South", label: "South" },
    { value: "East", label: "East" },
    { value: "West", label: "West" },
  ];

  const accessTypeOptions = [
    { value: "Internal stairs", label: "Internal Stairs" },
    { value: "External stairs", label: "External Stairs" },
    { value: "Ladder", label: "Ladder" },
    { value: "No access", label: "No Access" },
  ];

  const panelPlacementOptions = [
    { value: "2/2", label: "2/2" },
    { value: "1/4", label: "1/4" },
    { value: "NA", label: "NA" },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center">
          <Icon name="Home" size={20} className="text-secondary" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          Roof Engineering
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label="Roof Type"
          placeholder="Select roof type"
          options={roofTypeOptions}
          value={surveyData.roofType}
          onChange={handleChange.bind(null, "roofType")}
          error={errors.roofType}
          searchable
        />

        <Select
          label="Roof Condition"
          placeholder="Select roof condition"
          options={roofConditionOptions}
          value={surveyData.roofCondition}
          onChange={handleChange.bind(null, "roofCondition")}
          error={errors.roofCondition}
          searchable
        />

        <Input
          label="Total Roof Area (sq ft)"
          type="number"
          placeholder="e.g., 1000"
          step="0.01"
          value={surveyData.totalRoofAreaSqft}
          onChange={(e) => handleChange("totalRoofAreaSqft", e.target.value)}
          error={errors.totalRoofAreaSqft}
          className="w-full"
        />

        <Input
          label="Shadow Free Area (sq ft)"
          type="number"
          placeholder="e.g., 800"
          step="0.01"
          value={surveyData.shadowFreeAreaSqft}
          onChange={(e) => handleChange("shadowFreeAreaSqft", e.target.value)}
          error={errors.shadowFreeAreaSqft}
          className="w-full"
        />

        <Select
          label="Roof Orientation"
          placeholder="Select roof orientation"
          options={roofOrientationOptions}
          value={surveyData.roofOrientation}
          onChange={handleChange.bind(null, "roofOrientation")}
          error={errors.roofOrientation}
          searchable
        />

        <Input
          label="Parapet Height (ft)"
          type="number"
          placeholder="e.g., 3.5"
          step="0.1"
          value={surveyData.parapetHeightFt}
          onChange={(e) => handleChange("parapetHeightFt", e.target.value)}
          error={errors.parapetHeightFt}
          className="w-full"
        />

        <Input
          label="Number of Floors"
          type="number"
          placeholder="e.g., 2"
          min="1"
          value={surveyData.numberOfFloors}
          onChange={(e) => handleChange("numberOfFloors", e.target.value)}
          error={errors.numberOfFloors}
          className="w-full"
        />

        <Select
          label="Access Type"
          placeholder="Select access type"
          options={accessTypeOptions}
          value={surveyData.accessType}
          onChange={handleChange.bind(null, "accessType")}
          error={errors.accessType}
          searchable
        />

        <Select
          label="Panel Placement"
          placeholder="Select panel placement"
          options={panelPlacementOptions}
          value={surveyData.panelPlacement}
          onChange={handleChange.bind(null, "panelPlacement")}
          error={errors.panelPlacement}
          searchable
        />
      </div>
    </div>
  );
};

export default RoofEngineeringForm;
